import { useHistory } from "react-router-dom";

function CapitalOneDataPage() {
  const history = useHistory();
  return (
    <div className="grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 overflow-y-auto">
      <main className="flex flex-col gap-8 row-start-2 items-center sm:items-start">
        {/* RUTTER CODE START ============== */}
        <div
          style={{
            padding: "3.2rem",
            height: "100%",
            position: "relative",
          }}
        >
          <div className="flex flex-column items-center justify-center pb-4">
            <img
              style={{ height: 80, marginBottom: 20 }}
              alt=""
              src="/capitalone_logo.png"
            ></img>
          </div>

          <div className="text-xl text-center">
            <div className="text-center text-[24px] ">
              Information Capital One collects and how it is used:
            </div>
          </div>
          <div className="mt-8 w-2xl">
            <div>
              <div className="flex items-center">
                <div>
                  {/* <div className="ml-3 text-lg">Secure</div> */}
                  <div className="font-bold text-[16px]">
                    What We Collect (With Your Permission)
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="">
                <div>
                  When you give us access, we collect information directly from
                  your Intuit account. This includes:
                </div>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Details about your bills and invoices</li>
                  <li>Information on payments you've made to vendors</li>
                  <li>Vendor information (such as their name and address)</li>
                  <li>General ledger accounts</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-8 w-2xl">
            <div>
              <div className="flex items-center">
                <div>
                  {/* <div className="ml-3 text-lg">Secure</div> */}
                  <div className="font-bold text-[16px]">
                    How We Use Your Information:
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="">
                <div>
                  Based on the information we gather, we will conduct a Card
                  Acceptance review to share insights back to you regarding
                  vendor spend and reward opportunities. In addition, we may
                  also use data gathered to inform the services and products we
                  provide.
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-2xl">
            <div>
              <div className="flex items-center">
                <div>
                  {/* <div className="ml-3 text-lg">Secure</div> */}
                  <div className="font-bold text-[16px]">
                    This is an Ongoing Connection:
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="">
                <div>
                  You can request to unlink this connection at any time, and we
                  won't have access to your login credentials.
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "42px",
              marginBottom: ".8rem",
              marginRight: ".8rem",
              marginLeft: ".8rem",
            }}
            className=""
          >
            <div className="flex items-center justify-center flex-col ">
              <a href="./success" rel="noopener noreferrer">
                {/* <Link href=""> */}
                <button
                  className="max-w-sm rounded-md transition-colors bg-[#0070A8] hover:bg-[#015884] hover:border-transparent text-sm sm:text-base p-4 lg:px-24  cursor-pointer"
                  onClick={(e: any) => {
                    e.preventDefault();
                    history.push("/platforms" + history.location.search);
                  }}
                >
                  <span className="text-white font-semibold ">
                    Connect your account
                  </span>
                </button>

                {/* </Link>                      */}
              </a>

              <p className="mt-3 max-w-sm text-center ">
                <span
                  onClick={() => {
                    history.push("/" + history.location.search);
                  }}
                  className="text-[#0070A8] font-semibold cursor-pointer"
                >
                  Back to main page
                </span>
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-center flex-col sm:flex-row"></div>
        </div>
      </main>
    </div>
  );
}

export default CapitalOneDataPage;
